import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface CohortCountProps {
  count: number | undefined
  isLoading?: boolean
  className?: string
}

export function CohortCount({ count, isLoading, className }: CohortCountProps) {
  if (isLoading) {
    return (
      <Badge variant="outline" className={cn('bg-muted animate-pulse', className)}>
        <span className="invisible">0 cohorts</span>
      </Badge>
    )
  }

  if (count === undefined || count === 0) {
    return (
      <Badge variant="outline" className={cn('bg-gray-100 text-gray-600 border-gray-200', className)}>
        No cohorts
      </Badge>
    )
  }

  return (
    <Badge variant="outline" className={cn('bg-purple-100 text-purple-800 border-purple-200', className)}>
      {count} {count === 1 ? 'cohort' : 'cohorts'}
    </Badge>
  )
}
